import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import useUIContext from 'context/ui'

import s from './ContactButtonCTA.module.scss'
const cn = classNames.bind(s)

const CONTACT_EMAIL = 'make@myriad.video'

const ContactButtonCTA = ({ onClick, ...props }) => {
  const isFooterVisible = useUIContext((s) => s.isFooterVisible)
  const isPageTransitioning = useUIContext((s) => s.isPageTransitioning)
  const scrollY = useUIContext((s) => s.scrollY)
  const [isBelowFold, setIsBelowFold] = useState(false)

  const checkBelowFold = useCallback(() => {
    setIsBelowFold(scrollY.get() > window.innerHeight * 0.9)
  }, [scrollY])

  useEffect(() => {
    checkBelowFold()
    const unsubscribe = scrollY.onChange(checkBelowFold)
    window.addEventListener('resize', checkBelowFold, { passive: true })

    return () => {
      unsubscribe()
      window.removeEventListener('resize', checkBelowFold)
    }
  }, [scrollY, checkBelowFold])

  return (
    <a
      href={`mailto:${CONTACT_EMAIL}`}
      className={cn('button', { isPageTransitioning, isFooterVisible, isBelowFold })}
      onClick={onClick}
      {...props}
    >
      Contact Us
    </a>
  )
}

ContactButtonCTA.propTypes = {
  onClick: PropTypes.func,
}

export default ContactButtonCTA
